import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ADMIN_EMAILS } from '../../firebase/config';

export default function AdminRoute({ children }) {
  const { currentUser } = useAuth();

  
  if (!currentUser) {
    return <Navigate to="/admin" />;
  }

  
  const isAdmin = ADMIN_EMAILS.includes(currentUser.email);
  
  if (!isAdmin) {
    console.log('❌ Accès refusé - Email non admin:', currentUser.email);
    return <Navigate to="/dashboard" />;
  }

  console.log('✅ Accès admin autorisé pour:', currentUser.email);
  return children;
}